export default __webpack_public_path__ + "static/media/mutton.1b0c1d37.jpg";